import React, { Component } from "react";
import { Divider, Row, Layout, Button } from "antd";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";
import throttle from "lodash.throttle";
import PropTypes from "prop-types";
import BestCatsTable from "../../table/BestCatsTable";
import {
  FacebookShareButton,
  RedditShareButton,
  TwitterShareButton,
  VKShareButton,
  FacebookIcon,
  RedditIcon,
  TwitterIcon,
  VKIcon,
} from "react-share";
import VenatusAd from "../../ads/VenatusAd";
import VenatusAdWithPlaceholder from "../../ads/VenatusAdWithPlaceholder";
import {
  VENATUS_DESKTOP_LEADERBOARD,
  VENATUS_MOBILE_LEADERBOARD,
  VENATUS_MOBILE_INCONTENT,
  VENATUS_RICH_MEDIA_WITH_STICKY_VERTICAL,
  VENATUS_RICH_MEDIA,
} from "../../utilities/constants";

const shareURL = "https://mygamatoto.com/best-cats-for-range";

const { Content } = Layout;
// const convertBasedOnLevel = require("../../table/calc-stats");

export const initGA = () => {
  ReactGA.initialize(
    "G-MX6GYDK28N"
    // , {
    //   gaAddress: "https://onestoppress.com/analytics.js"
    // }
  );
};

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname + window.location.search });
};

class Range extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewportWidth: 0,
      compareCatsLevels: 30,
    };
  }
  componentDidMount() {
    this.saveViewportDimensions();
    window.addEventListener("resize", this.saveViewportDimensions);

    // initGA();
    // logPageView();

    document.title = "Best Cats for Range | Battle Cats Wiki for Cat Stats";
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.saveViewportDimensions);
  }

  saveViewportDimensions = throttle(() => {
    let adjustViewport;
    if (window.innerWidth < 636) {
      adjustViewport = 22;
    } else if (window.innerWidth < 948) {
      adjustViewport = 34;
    } else {
      adjustViewport = 46;
    }

    this.setState({
      viewportWidth: window.innerWidth - adjustViewport,
    });
  }, this.props.applyViewportChange);

  showModal = () => {
    this.setState({ isModalVisible: true });
  };

  handleCancel = () => {
    this.setState({ isModalVisible: false });
  };

  render() {
    const bestCats = [
      {
        key: "169-3",
        name: "Assassinlan Pasalan",
        number: "169-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 2750,
        damage: 832,
        range: 1250,
        kb: 1,
        speed: 4,
        dps: 68,
        target: "Area",
        tba: "12.33",
        anim: "5.03",
        spawn: "324.87",
        cost: 4500,
        ability: "u1Against allu2: b1Slowb2 (100% chance to slow for 3.0s)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "036-3",
        name: "Cyberpunk Cat",
        number: "036-3",
        form: "True",
        rarity: "Super Rare",
        level: 1,
        health: 500,
        damage: 1125,
        range: 1200,
        kb: 1,
        speed: 4,
        dps: 140,
        target: "Area",
        tba: "8.03",
        anim: "2.40",
        spawn: "158.20",
        cost: 3750,
        ability:
          "u1Against white, red, black, floating, angel, alien, zombie, relicu2: b1Slowb2 (100% chance to slow for 2.0s) \r\nu1General Abilitiesu2: b1Long Distanceb2 (Effective range 800~1200)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "240-3",
        name: "Sniper the Deadeye",
        number: "240-3",
        form: "True",
        rarity: "Super Rare",
        level: 1,
        health: 312,
        damage: 50,
        range: 1200,
        kb: 1,
        speed: 2,
        dps: 8,
        target: "Single",
        tba: "7.37",
        anim: "0.73",
        spawn: "158.20",
        cost: 900,
        ability:
          "u1Against white, red, black, floating, angel, alien, zombie, relicu2: b1Knockbackb2 (100% chance of knockback) b1Slowb2 (100% chance to slow for 3.0s)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "054-2",
        name: "Filibuster Cat",
        number: "054-2",
        form: "Evolved",
        rarity: "Uber Super Rare",
        level: 1,
        health: 500,
        damage: 150,
        range: 1000,
        kb: 1,
        speed: 18,
        dps: 5,
        target: "Area",
        tba: "38.00",
        anim: "11.37",
        spawn: "324.87",
        cost: 500,
        ability:
          "u1Against white, red, black, floating, angel, alien, zombie, relicu2: b1Freezeb2 (100% chance to freeze for 5.0s)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "430-2",
        name: "Hacker Geek Cat",
        number: "430-2",
        form: "Evolved",
        rarity: "Super Rare",
        level: 1,
        health: 500,
        damage: 1000,
        range: 1000,
        kb: 1,
        speed: 4,
        dps: 125,
        target: "Area",
        tba: "8.03",
        anim: "2.40",
        spawn: "158.20",
        cost: 3750,
        ability:
          "u1Against white, red, black, floating, angel, alien, zombie, relicu2: b1Weakenb2 (100% chance to weaken by 50% for 2.67s) \r\nu1General Abilitiesu2: b1Long Distanceb2 (Effective range 800~1200)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "172-3",
        name: "Piccolan Pasalan",
        number: "172-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 3000,
        damage: 28,
        range: 940,
        kb: 1,
        speed: 4,
        dps: 2,
        target: "Area",
        tba: "16.43",
        anim: "3.13",
        spawn: "324.87",
        cost: 4500,
        ability:
          "u1Against allu2: b1Weakenb2 (100% chance to weaken by 50% for 6.0s) b1Freezeb2 (100% chance to freeze for 3.0s)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "136-3",
        name: "Ultima Galaxy Cosmo",
        number: "136-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 4000,
        damage: 8375,
        range: 850,
        kb: 4,
        speed: 54,
        dps: 405,
        target: "Area",
        tba: "20.67",
        anim: "10.70",
        spawn: "131.53",
        cost: 5850,
        ability:
          "u1Against floating, angelu2: b1Freezeb2 (100% chance to freeze for 5.0s) b1Knockbackb2 (100% chance of knockback)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "171-3",
        name: "Lufalan Pasalan",
        number: "171-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 3000,
        damage: 18250,
        range: 720,
        kb: 1,
        speed: 4,
        dps: 2245,
        target: "Single",
        tba: "8.13",
        anim: "3.50",
        spawn: "324.87",
        cost: 4500,
        ability:
          "u1General Abilitiesu2: b1Criticalb2 (20% chance of a critical hit)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "189-2",
        name: "Mystica CC",
        number: "189-2",
        form: "Evolved",
        rarity: "Uber Super Rare",
        level: 1,
        health: 3750,
        damage: 3200,
        range: 690,
        kb: 3,
        speed: 14,
        dps: 248,
        target: "Area",
        tba: "12.97",
        anim: "2.33",
        spawn: "128.20",
        cost: 5700,
        ability:
          "u1Against blacku2: b1Strongb2 (inflicts 1.5x damage, takes only 0.5x damage)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "035-3",
        name: "Ultralan Pasalan",
        number: "035-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 3000,
        damage: 5000,
        range: 650,
        kb: 1,
        speed: 4,
        dps: 265,
        target: "Area",
        tba: "18.93",
        anim: "2.97",
        spawn: "324.87",
        cost: 4500,
        ability:
          "u1Against white, red, black, floating, angel, alien, zombie, relicu2: b1Freezeb2 (100% chance to freeze for 2.0s) b1Knockbackb2 (100% chance of knockback)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "565-2",
        name: "Bikinilan Pasalan",
        number: "565-2",
        form: "Evolved",
        rarity: "Uber Super Rare",
        level: 1,
        health: 3000,
        damage: 2500,
        range: 650,
        kb: 1,
        speed: 4,
        dps: 132,
        target: "Area",
        tba: "18.93",
        anim: "2.97",
        spawn: "324.87",
        cost: 4500,
        ability:
          " b1Surge Attacksb2 (100% chance to perform Surge Attacks for 3.33s (Range: 150~1050))",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "260-3",
        name: "Almighty Aphrodite",
        number: "260-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 7750,
        damage: 6000,
        range: 600,
        kb: 4,
        speed: 7,
        dps: 502,
        target: "Area",
        tba: "11.97",
        anim: "4.07",
        spawn: "131.53",
        cost: 4500,
        ability:
          "u1Against alienu2: b1Massive Damageb2 (inflicts 3.0x damage) \r\nu1General Abilitiesu2: b1Long Distanceb2 (Effective range 450~850)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
    ];

    // console.log(typeof(bestCats))

    return (
      <div>
        <div className="pagetitle">
          <h1 style={{ padding: "10px 0 0 0", marginBottom: "6px" }}>
            Best Cats
          </h1>
          <Divider style={{ margin: "0 0 0 0", padding: "0 0 0 0" }} />
        </div>
        <Layout style={{ padding: "0 12px 0 12px", background: "white" }}>
          <Content className="flexible-width">
            <Row style={{ padding: "16px 0 0 0" }}>
              <div>
                {this.state.viewportWidth > 1024 ? (
                  <VenatusAdWithPlaceholder
                    placementId={VENATUS_DESKTOP_LEADERBOARD}
                  />
                ) : (
                  ""
                  // <VenatusAdWithPlaceholder
                  //   placementId={VENATUS_MOBILE_LEADERBOARD}
                  // />
                )}
                <h2 style={{ marginTop: "12px", fontSize: "24px" }}>
                  Best Cats for Range
                </h2>
                <p></p>
                <div>
                  What are the best cats in the Battle Cats with the highest
                  range? Which ones outrange even cats like Professor A,
                  Camelle, and other enemies with long range?
                </div>
                <p></p>
                <div>
                  Comparing the stats for the top 12 cats gives us the list
                  below, with the longest range at the top.{" "}
                </div>
                <p></p>
                <div>
                  PS. The only reason this list starts with 12 cats is to fit in
                  Aphrodite.{" "}
                </div>
                <p></p>
                <i>Last updated: 15 March 2021</i>
              </div>
            </Row>

            <Row style={{ margin: "16px 0 0 0" }}>
              <FacebookShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                style={{ marginRight: "0.25rem" }}
              >
                <FacebookIcon size={32} round />
              </FacebookShareButton>
              <TwitterShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                title="MyGamatoto - Best Cats for Range"
                style={{ marginRight: "0.25rem" }}
              >
                <TwitterIcon size={32} round />
              </TwitterShareButton>
              <RedditShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                style={{ marginRight: "0.25rem" }}
              >
                <RedditIcon size={32} round />
              </RedditShareButton>
              <VKShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                title="MyGamatoto - Best Cats for Range"
                style={{ marginRight: "0.25rem" }}
              >
                <VKIcon size={32} round />
              </VKShareButton>
            </Row>
            {this.state.viewportWidth > 1024 ? (
              ""
            ) : (
              <div style={{ margin: "10px 0 0 0" }}>
                <div
                  class="vm-placement"
                  id="vm-av"
                  data-format="isvideo"
                ></div>
              </div>
            )}
            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  12.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[11].number +
                      ".png"
                    }
                    alt={bestCats[11].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[11].number.slice(0, 3) +
                          "/" +
                          bestCats[11].name
                        }
                      >
                        {bestCats[11].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Goddess of love, beauty and pride. Blessed by the fruit of
                  creation, life and death serve her pleasure. Massive
                  Long-Range Area damage to Aliens.
                  <p></p>
                  <b>Pros: </b>This S tier uber is a must-have for all players.
                  With solid damage, good health and a decent amount of
                  knockbacks, she is probably the best long-range attacker for
                  all enemy types.
                  <p></p>
                  <b>Cons: </b>As with all long-distance cats, she has a
                  sizeable blind spot that makes it important to protect her
                  well with close-ranged attackers in your lineup.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[7].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Almighty Aphrodite"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="6681079332"
            /> */}

            {/* <div id="waldo-tag-14680"></div> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_DESKTOP_LEADERBOARD}
              />
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_LEADERBOARD}
              />
            )}

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  11.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[10].number +
                      ".png"
                    }
                    alt={bestCats[10].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[10].number.slice(0, 3) +
                          "/" +
                          bestCats[10].name
                        }
                      >
                        {bestCats[10].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Blistering barnacles! Seems like this bodacious beach babe has
                  100% chance of Area Surge attacks
                  <p></p>
                  <b>Pros: </b>Thanks to its long surge attack, it's great at
                  clearing peons. Also does well against enemies with very high
                  health or have many knockbacks, like THE SLOTH or Rain D.
                  <p></p>
                  <b>Cons: </b>Long recharge time plus a potential blind spot
                  makes it very risky to rely on this cat as the main damage
                  dealer in any lineup.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[6].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Bikinilan Pasalan"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  10.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[9].number +
                      ".png"
                    }
                    alt={bestCats[9].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[9].number.slice(0, 3) +
                          "/" +
                          bestCats[9].name
                        }
                      >
                        {bestCats[9].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Tired of scaring children, Luga decided to reinvent himself as
                  that famous masked hero. Freezes and knocks back non-Metal
                  enemies (Area Atk.)
                  <p></p>
                  <b>Pros: </b>Great at pushing back the boss or enemy line,
                  sometimes even knocking them behind their base.
                  <p></p>
                  <b>Cons: </b>One of the longest time between attacks in the
                  Nekoluga family. Be prepared for a drawn out battle when using
                  him.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[9].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Ultralan Pasalan"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  9.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[8].number +
                      ".png"
                    }
                    alt={bestCats[8].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[8].number.slice(0, 3) +
                          "/" +
                          bestCats[8].name
                        }
                      >
                        {bestCats[8].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Joining the fight from Merc Storia! Touching her coffin will
                  cause it to crumble to dust. Long-range Area attacks, Strong
                  vs Black.
                  <p></p>
                  <b>Pros: </b>Like an{" "}
                  <Link to={"/catinfo/260/Almighty%20Aphrodite"}>
                    Aphrodite
                  </Link>{" "}
                  equivalent, but against blacks.
                  <p></p>
                  <b>Cons: </b>Blacks tend to be great pushers, and she also
                  fails to outrange enemies like Director Kurosawah, which
                  limits her use against them. Overall there are usually better
                  ubers to employ against black enemies.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[8].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Mystica CC"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="6681079332"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  8.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[7].number +
                      ".png"
                    }
                    alt={bestCats[7].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[7].number.slice(0, 3) +
                          "/" +
                          bestCats[7].name
                        }
                      >
                        {bestCats[7].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  It seems like this one is a straw-hatted pirate of some kind.
                  But we really can't be sure. Massive damage vs. one enemy.
                  (Might Crit.)
                  <p></p>
                  <b>Pros: </b>Amazing damage (also on the{" "}
                  <Link to={"/best-cats-for-attack"}>Best Cats for Attack</Link>{" "}
                  list), plus one of the shortest time between attacks in the
                  Nekoluga family. Its ability to Crit makes it a strong
                  contender for those Metal Cyclone stages.
                  <p></p>
                  <b>Cons: </b>Attacks only one enemy. Need to be careful that
                  its attack isn't wasted on a peon.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[7].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Lufalan Pasalan"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  7.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[6].number +
                      ".png"
                    }
                    alt={bestCats[6].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[6].number.slice(0, 3) +
                          "/" +
                          bestCats[6].name
                        }
                      >
                        {bestCats[6].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  He has reached the edge of the universe and seen the truth.
                  Area attacks have 100% chance of knockback & freeze vs
                  Floating/Angels.
                  <p></p>
                  <b>Pros: </b>Great at whittling down strong enemies from the
                  backline, such as Rain D or THE SLOTH.
                  <p></p>
                  <b>Cons: </b>His high speed may cause him to run too quickly
                  towards the enemies, especially with the Cat Cannon. This is
                  also an issue with enemies like Sunfish Jones, where he has a
                  marginally higher range but has a tendency to run into its
                  range.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[6].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Ultima Galaxy Cosmo"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 8px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  6.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[5].number +
                      ".png"
                    }
                    alt={bestCats[5].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[5].number.slice(0, 3) +
                          "/" +
                          bestCats[5].name
                        }
                      >
                        {bestCats[5].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>A totally unknown extraterrestrial
                  lifeform of unimaginable power... or maybe just a weird Cat?
                  Freezes and weakens all enemies in area atk range.
                  <p></p>
                  <b>Pros: </b>Extra effective against enemies with very strong
                  attacks. Its weaken ability grants an extra 3 seconds of
                  breathing room.
                  <p></p>
                  <b>Cons: </b>Even{" "}
                  <Link to={"/catinfo/001/Mohawk%20Cat"}>Mohawk Cat</Link> has
                  higher damage.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[5].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Piccolan Pasalan"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="6681079332"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  5.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[4].number +
                      ".png"
                    }
                    alt={bestCats[4].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[4].number.slice(0, 3) +
                          "/" +
                          bestCats[4].name
                        }
                      >
                        {bestCats[4].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  An expert techie who knows any machine inside and out.
                  Yesterday, his own blog was hacked... Long-distance attacks
                  100% Weaken non-Metal.
                  <p></p>
                  <b>Pros: </b>Great when paired with{" "}
                  <Link to={"/catinfo/036/Cyberpunk%20Cat"}>Cyberpunk Cat</Link>
                  , but not so useful alone unless stacked significantly.
                  <p></p>
                  <b>Cons: </b>Weakens for only 2+ seconds, so by the time the
                  enemy reaches your frontline, it may not be weakened for much
                  longer.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[4].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Hacker Geek Cat"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  4.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[3].number +
                      ".png"
                    }
                    alt={bestCats[3].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[3].number.slice(0, 3) +
                          "/" +
                          bestCats[3].name
                        }
                      >
                        {bestCats[3].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Uses special powers to interrupt time. Stops the movement of
                  enemies. Summon when you are losing ground.
                  <p></p>
                  <b>Pros: </b>Can be stacked...ideally with a Speed Up.
                  <p></p>
                  <b>Cons: </b>Slowest time between attacks and spawn rates of
                  nearly all the cats. He won't be doing much for you except in
                  the most desperate of situations...assuming they exist.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[3].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Filibuster Cat"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 8px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  3.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[2].number +
                      ".png"
                    }
                    alt={bestCats[2].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[2].number.slice(0, 3) +
                          "/" +
                          bestCats[2].name
                        }
                      >
                        {bestCats[2].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Free agent sniper, 31 years old, who bought all their
                  equipment secondhand off of Daveslist. Long distance atk. with
                  non-metal knockback.
                  <p></p>
                  <b>Pros: </b>Works very well with{" "}
                  <Link to={"/catinfo/036/Cyberpunk%20Cat"}>Cyberpunk Cat</Link>
                  .<p></p>
                  <b>Cons: </b>Targets only one enemy at a time. Best used in
                  stages where the peons are controllable.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[2].damage}  */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Sniper the Deadeye"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  2.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[1].number +
                      ".png"
                    }
                    alt={bestCats[1].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[1].number.slice(0, 3) +
                          "/" +
                          bestCats[1].name
                        }
                      >
                        {bestCats[1].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Having mastered virtual space, he's moved on to losing his
                  shirt in the cryptocurrency market. Long-range area attacks
                  slow non-Metal.
                  <p></p>
                  <b>Pros: </b>With its long-distance attacks and Slow ability,
                  this cat shines when it's stacked.
                  <p></p>
                  <b>Cons: </b>Best used with Speed Up when trying to stack it,
                  else there'll be a long wait ahead of you. As with most cats
                  in this list, meatshielding well is a must too.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[1].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Cyberpunk Cat"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="6681079332"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}

            <Row style={{ padding: "0px 0 0px 0" }}>
              <Row style={{ padding: "0px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  1.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[0].number +
                      ".png"
                    }
                    alt={bestCats[0].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[0].number.slice(0, 3) +
                          "/" +
                          bestCats[0].name
                        }
                      >
                        {bestCats[0].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Is it a Cat? Or an overly melodramatic comic-book assassin of
                  some kind? Slows enemies with Area Attacks.
                  <p></p>
                  <b>Pros: </b>Outranges even Sunfish and Spacefish Jones.
                  <p></p>
                  <b>Cons: </b>His damage isn't much to write home about. While
                  its DPS is decent for a Nekoluga, like with all the rest of
                  them, it still only works with proper meatshielding.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Assassinlan Pasalan"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="6681079332"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}

            <Row style={{ padding: "6px 0 6px 0" }}>
              <Divider />
              <h3>Compare all 12 cats below</h3>
              <BestCatsTable
                selectedCats={bestCats}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row
              style={{
                padding: "24px 20px 18px 20px",
                backgroundColor: "#ffa50038",
                textAlign: "center",
                margin: "0 0 8px 0",
              }}
            >
              <div style={{ fontSize: "16px" }}>
                Want to compare the stats of any cat in The Battle Cats?
              </div>
              <Divider
                style={{ backgroundColor: "orange", marginTop: "12px" }}
              ></Divider>
              <Button href="/comparecats" size="large">
                Compare more cats
              </Button>
            </Row>
          </Content>
        </Layout>
        {this.state.viewportWidth > 1024 ? (
          <div>
            <VenatusAd
              placementId={VENATUS_RICH_MEDIA_WITH_STICKY_VERTICAL}
              style={{ display: "none" }}
            />
          </div>
        ) : (
          <div>
            <VenatusAd
              placementId={VENATUS_RICH_MEDIA}
              style={{ display: "none" }}
            />
          </div>
        )}
        {/* <HorizontalAdPopup
          dataAdClient="ca-pub-1920730948516638"
          dataAdSlot="6015153906"
        ></HorizontalAdPopup> */}
        {/* <div id="waldo-tag-14678"></div> */}
      </div>
    );
  }
}

export default Range;

Range.propTypes = {
  applyViewportChange: PropTypes.number,
};

Range.defaultProps = {
  applyViewportChange: 250,
};



// WEBPACK FOOTER //
// ./src/components/content/bestcats/Range.js